import type { ConjTimelineEntry, Tense } from "@/lib/types";
import { cn } from "@/lib/cn";

interface Props {
  timeline: ConjTimelineEntry[];
  gerund?: string;
  currentTense?: Tense;
  compact?: boolean;
}

export function VerbTimeline({
  timeline,
  gerund,
  currentTense,
  compact = false,
}: Props) {
  return (
    <div className="w-full" aria-label="Tabla de formas de yo">
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {timeline.map((entry) => {
          const active = entry.tense === currentTense;
          return (
            <div
              key={entry.tense}
              className={cn(
                "rounded-2xl border px-3 text-left min-w-0",
                compact ? "py-2" : "py-3",
                active
                  ? "border-brand-violet bg-brand-violet/10 ring-2 ring-brand-violet/15"
                  : "border-brand-border bg-brand-surface/80",
              )}
            >
              <div className="text-[9px] uppercase tracking-widest font-black text-brand-muted leading-tight">
                {entry.cue}
              </div>
              <div className="mt-1 text-[10px] font-extrabold text-brand-violet leading-tight">
                {entry.label}
              </div>
              <div
                className={cn(
                  "mt-1 font-display text-brand-ink leading-tight break-words",
                  compact ? "text-sm" : "text-base",
                )}
              >
                {entry.form}
              </div>
            </div>
          );
        })}
      </div>
      {gerund && (
        <div className="mt-2 rounded-2xl bg-brand-saffron/15 border border-brand-saffron/30 px-3 py-2 flex items-center justify-between gap-3">
          <span className="text-[10px] uppercase tracking-widest font-black text-brand-muted">
            Gerundio
          </span>
          <span className="font-display text-sm text-brand-ink">{gerund}</span>
        </div>
      )}
    </div>
  );
}
